/**
 * Group catalog items into per-type THEME buckets (ADR-0113), preserving the input order (the catalog already
 * arrives sort-ordered): a theme appears in first-seen order, items keep their order within it. Un-themed items
 * bucket under `null` (the catalog's default group). Turns one flat "all pets" wall into browseable themed
 * shelves as the catalog grows toward hundreds.
 */
export function groupByTheme<T>(
  items: readonly T[],
  themeOf: (item: T) => string | null,
): { theme: string | null; items: T[] }[] {
  const order: (string | null)[] = [];
  const buckets = new Map<string | null, T[]>();
  for (const item of items) {
    const theme = themeOf(item);
    let bucket = buckets.get(theme);
    if (!bucket) {
      bucket = [];
      buckets.set(theme, bucket);
      order.push(theme);
    }
    bucket.push(item);
  }
  return order.map((theme) => ({ theme, items: buckets.get(theme)! }));
}
